import React from 'react';
import get from 'lodash/get';

import ContactUsContent from '../../../components/ContactUsContent/ContactUsContent';
import withPensionExpertTier from '../../../util/pensionExpertTier/withPensionExpertTier';
import { pronouns } from '../../../util/pensionExpertTier/pensionExpertTierHelper';

const ContactUs = (props) => {
  const {
    pensionExpert,
    firstName,
    email,
    expertTier,
    expertRoleTitle,
    isPoolExpert,
  } = props;

  const heading = isPoolExpert
    ? 'Hello, you’re with our Pension Experts team'
    : `Hello, I’m ${get(pensionExpert, 'firstName')}, your ${expertRoleTitle}`;
  const message = `If you have any questions about your pension, please feel free to contact ${pronouns(expertTier).obj}.`;

  return (
    <ContactUsContent
      heading={heading}
      message={message}
      customerFirstName={firstName}
      customerEmail={email}
      source={'Dashboard'}
    />
  );
};

export default withPensionExpertTier(ContactUs);
